import type { ComponentProps } from 'react'
import { cn } from '../../lib/cn'
import { controlClass, useFieldControl } from './field'

/** A line of text in a Field, which gives it its label, hint and error. */
export function TextInput({ className, ...props }: ComponentProps<'input'>) {
  return <input className={cn(controlClass, className)} {...useFieldControl()} {...props} />
}
